enum ActionResultType {
  NOTHING,
  DELETE,
  UPDATE,
  ADD,
  MODAL,
  LINK,
  REJET_COLLECTIVITE,
}

export default ActionResultType;
